import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Axios from 'axios';

const useStyles = makeStyles((theme) => ({
    paper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function Forgotten(props) {
    const [username, setUserName] = useState(null)
    const [notFound, setNotFound] = useState(false)
    const [emailSent, setEmailSent] = useState(false)

    const classes = useStyles();

    const handleUsername = (e) => {
        setUserName(e.target.value)
    }


    const retrieve = (e) => {
        e.preventDefault()
        Axios.post(props.base_url + 'endpoint/login', { username: username, operation: 'forgotten' })
            .then(res => {
                if (res.data === 'No email found') {
                    setNotFound(true)
                }
                else {
                    console.log(res.data)
                    setEmailSent(true)
                }
            })

    }

    return (
        <Container component="main" maxWidth="xs" style={{ display: 'flex', height: '100vh', alignItems: 'center' }}>
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography style={{ textAlign: 'center' }} component="h1" variant="h5">
                    Recuperar Contraseña
                </Typography>
                {emailSent &&
                    <p className="mt-3">Se ha enviado la contraseña al correo electrónico</p>
                }
                {!emailSent &&
                    <form className={classes.form} noValidate onSubmit={retrieve}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Usuario"
                            name="username"
                            autoFocus
                            onChange={handleUsername}
                        />
                        {notFound && <p style={{ color: 'red' }}>No se encontró ningun correo que coincida</p>}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            Confirmar
                    </Button>
                    </form>
                }
            </div>

        </Container>
    );
}